export default __webpack_public_path__ + "a42118c.png";